import api from "../../../services/api";

export const getMonthlyForecastEcomm = async (
  month = "2025-04",
) => {
  const response = await api.get("/api/forecast/ecommerce/monthly_data", {
    params: { month },
  });
  return response.data;
};
